import { Tooltip } from "antd";
import { Info } from "lucide-react";

const RULES = [
  "At least 8 characters",
  "At least one uppercase letter",
  "At least one lowercase letter",
  "At least one digit",
  "At least one special character",
];

export default function PasswordPolicyHint({ size = 14, className = "" }) {
  const body = (
    <ul className="m-0 pl-4 list-disc">
      {RULES.map((r) => (
        <li key={r}>{r}</li>
      ))}
    </ul>
  );
  return (
    <Tooltip title={body} placement="topRight">
      <Info
        className={`inline-block text-mahogany hover:text-cocoa cursor-help ${className}`}
        style={{ width: size, height: size }}
        aria-label="Password policy"
      />
    </Tooltip>
  );
}
